import React from "react";
import Styled from "styled-components";

import headshot from "../assets/headshot.jpg";

const About = function() {
  const Container = Styled.div`
  display: flex;
  justify-content: center;

  @media (max-width: 900px) {
    flex-direction: column;
}
    `;

  const Me = Styled.div`
    display: flex;
    align-items: center;
    flex-basis: auto;

    @media (max-width: 900px) {
        flex-direction: column;
        justify-content: center;
        align-content: center;
    }

    @media (max-width: 425px) {
        width: 400px;
    }

    @media (max-width: 375px) {
      width: 375px;
    }

    @media (max-width: 320px) {
      width: 320px;
    }
    `;

  const Img = Styled.img`
    width: 200px;
    margin: 50px;
    filter: gray;
    -webkit-filter: grayscale(1);
    -webkit-transition: all .8s ease-in-out;

    &:hover {
        filter: none;
        -webkit-filter: grayscale(0);
        -webkit-transform: scale(1.01);
    }

    @media (max-width: 700px) {
        width: 100px;
        margin: 0px;
    }
    `;

  const Info = Styled.p`
        width: 500px;
        font-size: large;
        font-style: oblique;
        font-weight: 300;
        letter-spacing: 2px;
        line-height: 1.6;
        text-align: left;
        word-wrap: break-word;
        -webkit-transition: all .8s ease-in-out;

        @media (max-width: 900px) {
            font-size: medium;
        }

        @media (max-width: 700px) {
            font-size: small;
            width: 300px;
        }
    `;

  const Blockqoute = Styled.span`
        
        font-family: Georgia, serif;
        font-size: 18px;
        font-style: italic;
        width: 500px;
        margin: 0.25em 0;
        padding: 0.25em 15px;
        line-height: 1.45;
        position: relative;
        color: #383838;

        &:before {
            display: block;
            content: open-quote;
            font-size: 80px;
            position: absolute;
            left: -20px;
            top: -20px;
            color: #7a7a7a;
        }

        @media (max-width: 700px) {
          font-size: 20px;
      }
    `;

  return (
    <Container>
      <Me>
        <Img src={headshot} />
        <Info>
          <Blockqoute />
          I am a Full-Stack Web Developer, meaning that I can transform your
          idea and develop it from the ground up and deploy it so that the users
          can see your idea realized. Or I can help you with the Back-End or
          Front-End your choice. Some of the technologies that I have worked
          with so far are ReactJS, NodeJS, ExpressJS, Ruby, Rails, PostgreSQL
          and others. Not what you are looking for do not worry, libraries and
          frameworks come and go, but my determination and love for developing
          will always be there to learn and adapt for whatever comes my
          way.
        </Info>
      </Me>
    </Container>
  );
};

export default About;



// WEBPACK FOOTER //
// ./src/Components/About.jsx